import React from 'react';

function FixedHeaderFooterPreview() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="108"
      height="108"
      viewBox="0 0 108 108"
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <path fill="#FFF" d="M0 0H108V108H0z" />
        <path
          fill="#EFEFEF"
          d="M93 99a4 4 0 014 4v6H10v-6a4 4 0 014-4h79zm0-29a4 4 0 014 4v12a4 4 0 01-4 4H14a4 4 0 01-4-4V74a4 4 0 014-4h79zm0-29a4 4 0 014 4v12a4 4 0 01-4 4H14a4 4 0 01-4-4V45a4 4 0 014-4h79zm0-29a4 4 0 014 4v12a4 4 0 01-4 4H14a4 4 0 01-4-4V16a4 4 0 014-4h79z"
        />
        <path fill="currentColor" d="M0 0H108V22H0z" />
      </g>
    </svg>
  );
}

export default FixedHeaderFooterPreview;



// WEBPACK FOOTER //
// ./src/components/modules/Examples/FixedHeaderFooterPreview.js